'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _safelySetInnerHtml = require('safely-set-inner-html');

var _safelySetInnerHtml2 = _interopRequireDefault(_safelySetInnerHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var textToHTML = function textToHTML(text) {
  var allowedTags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var allowedAttributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  if (!text) {
    return null;
  }

  var instance = new _safelySetInnerHtml2.default({
    ALLOWED_TAGS: ['em', 'strong', 'b', 'br', 'span'].concat(_toConsumableArray(allowedTags)),
    ALLOWED_ATTRIBUTES: ['class', 'className'].concat(_toConsumableArray(allowedAttributes))
  });

  return instance.transform(text);
};

exports.default = textToHTML;